export default __webpack_public_path__ + "static/media/svg2.ccfc5e48.svg";